import { Box, SxProps, Theme } from '@mui/material';

const rootStyles: SxProps<Theme> = {
  maxHeight: theme => theme.mixins.toolbar.minHeight,
};

export default function InsightLogo() {
  return <Box component='img' sx={rootStyles} src='/insight-logo.png' alt='Insight logo' />;
}
